import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import MessageCenter from './pages/MessageCenter';
import {useEffect} from "react";
import ProtectedRoute from "./libs/ProtectedRoute";
import Logout from "./pages/Logout";
import {setAxiosSetting} from "./libs/axiosInstant";

function App() {

    const api = JSON.parse(localStorage.getItem('api'));
    if(api){
        setAxiosSetting(api.token, api.endpoint)
    }

    return (
        <Router>
            <Routes>
                <Route path="/" element={<ProtectedRoute><MessageCenter/></ProtectedRoute>}>
                    <Route path=":slug" element={<ProtectedRoute><MessageCenter/></ProtectedRoute>} />
                    <Route path=":slug/:id" element={<ProtectedRoute><MessageCenter/></ProtectedRoute>} />
                </Route>
                <Route path="/login" element={<Login/>}/>
                <Route path="/register" element={<Register/>}/>
                <Route path="/logout" element={<Logout/>}/>
            </Routes>
        </Router>
    );
}

export default App;
